export default function Spinner({ message = "로딩 중…" }) {
  return (
    <div className="py-8 px-4 text-center">
      <div className="w-3.5 h-3.5 border-[1.5px] border-text-tertiary border-t-text-secondary rounded-full animate-spin mx-auto mb-2.5" />
      <div className="text-sub text-text-tertiary">{message}</div>
    </div>
  );
}
